<p class="rejected-reason orange" *ngIf="expense.underInvestigation">
  <strong>Reason for Investigation:</strong> {{ expense.reasonForInvestigation }}
</p>
<p class="rejected-reason" *ngIf="expense.state == ExpenseClaimState.Rejected">
  <strong>Rejection Reason:</strong> {{ expense.rejectionReason }}
</p>
